import apiGraphQL from './apiGraphQL';
import {AxiosPromise} from 'axios';

export function updatePlayer(input: {
  id: number;
  number?: number;
  isActive?: boolean;
}) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `mutation UpdatePlayer($input: UpdatePlayerInput!) {
            updatePlayer(input: $input) {
              id
            }
          }`,
          variables: {
            input,
          },
        })
        .then(response => {
          resolve(response.data);
        })
        .catch((e: Error) => {
          console.error(e);
          reject(e);
        });
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
}
